<template>
    <v-flex xs12 class="businesses">
        <feature-event v-if="!$vuetify.breakpoint.xs"></feature-event>
        <v-layout row wrap my-4 class="businesses__search__block">
            <v-flex xs12 mb-3>
                <span class="form-control__label">{{businessesConstants.LOCATION}}</span>
                <v-layout row wrap>
                    <v-flex xs12 class="businesses__search" v-click-outside="closeLocationSuggestions" >
                        <v-text-field
                            solo
                            v-model="location"
                            @keyup="onLocationChange"                                                      
                            @input="fetchEntriesDebounceLocationSuggestions()"
                            @focus="showLocationSuggestions()"
                            @keydown.down="onArrowDown(locationSuggestions, businessesConstants.LOCATION_COUNTER)"
                            @keydown.up="onArrowUp(locationSuggestions, businessesConstants.LOCATION_COUNTER)"
                            @keydown.enter="onEnter(locationSuggestions, businessesConstants.LOCATION_COUNTER)"
                            :label="getLocationPlaceholder()"
                            append-icon="my_location"
                            @click:append="populateCurrentLocation"
                            hide-details
                            :class="['form-control small mr-3', isCurrentLoc?'current-loc':'']"
                            data-qe-id="location-search">
                        </v-text-field>
                        <v-flex class="businesses__search__result inner-scrollbar"
                        :ref="businessesConstants.LOCATION_COUNTER" v-if="locationSuggestions.length > 0 && !locationNotFoundError && !hideLocationsSuggestions">
                            <v-flex v-for="(item,i) in locationSuggestions" :key="i">
                                <v-flex tag="span" :class="{ 'is-active': i === counters.locationsCounter }" @click="selectLocationDropDown(item)">
                                    {{item}}
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex
                xs12
                sm9
                pr-3
                class="businesses__search search_establishments"
                v-click-outside="closeEstablismentSuggestions">
                <v-text-field
                    :label="businessesConstants.SEARCH_YPO_ESTABLISHMENTS"
                    solo
                    class="form-control"
                    v-model="establishmentsSearchText"
                    @input="fetchEntriesDebounceEstablishmentSuggestions()"
                    @focus="showEstablishmentSuggestions()"
                    hide-details
                    @keydown.down="onArrowDown(establishmentSuggestions, businessesConstants.ESTABLISHMENT_COUNTER)"
                    @keydown.up="onArrowUp(establishmentSuggestions, businessesConstants.ESTABLISHMENT_COUNTER)"
                    @keydown.enter="onEnter(establishmentSuggestions, businessesConstants.ESTABLISHMENT_COUNTER)"
                    data-qe-id="YPO-owned-establishments-search">
                </v-text-field>
                <v-flex class="businesses__search__result inner-scrollbar"
                 :ref="businessesConstants.ESTABLISHMENT_COUNTER" v-show="establishmentSuggestions.length > 0 && !hideEstablishmentSuggestions">
                    <v-flex v-for="(item,i) in establishmentSuggestions" :key="i">
                        <v-flex tag="span" :class="{ 'is-active': i === counters.establishmentsCounter }" @click="selectEstablishments(item)">{{item}}</v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex xs4 sm2 class="businesses__search-btn__block">
                <v-btn class="primary_btn businesses__search-btn" @click="getSearchResults()" data-qe-id="search_btn">{{businessesConstants.SEARCH}}</v-btn>
            </v-flex>
            <v-flex xs2 sm1 text-xs-right text-sm-center>
                <span class="filter-icon" @click="showfilters()">
                    <i class="fas fa-sliders-h"></i>
                </span>
            </v-flex>
        </v-layout>
        <business-active-filters v-show="!showBusinessFilters" 
            :filtersEnabled="filtersEnabled" 
            @filters="doRefineFilters" 
            :distanceSwitch="distanceSwitch"
            ref="activeFilters">
        </business-active-filters>
        <v-flex class="businesses__results_view">
            <business-filters v-show="showBusinessFilters" 
                :filtersEnabled="filtersEnabled" 
                :filtersUpdationDate="filtersUpdationDate"
                @distanceSwitch="setDistanceSwitch"
                @filters="doRefineFilters" ref="filters">
            </business-filters>
            <v-layout row wrap>
                <v-flex xs12 sm7 lg8 v-if="$vuetify.breakpoint.xs">
                    <BusinessesMap :mapList="assetMapPins" :centerTo="maplocation"></BusinessesMap>
                </v-flex>
                <v-flex xs12 sm5 lg4 v-if="isSearchClicked">
                    <v-flex text-xs-left class="sort-selector">
                        <span>{{businessesConstants.SORT_BY}}</span>
                        <v-menu offset-y class="ypo_cta_blue_color" attach content-class="asset-results_menu">
                            <v-flex
                                mb-1
                                slot="activator"
                                class="sort-selection"
                                data-qe-id="search-sort-by">
                                &nbsp; {{sortoption}}
                                <v-icon size="19">arrow_drop_down</v-icon>
                            </v-flex>
                            <v-list>
                                <v-list-tile v-for="(sort) in businessesSortOptions" @click="doSort(sort)" :key="sort.key" data-qe-id="sort_options">
                                    {{sort.label}}
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-flex
                            mt-5
                            v-if="isPending"
                            justify-center
                            text-xs-center>
                            <v-progress-circular indeterminate color="grey"></v-progress-circular>
                        </v-flex>
                        <v-flex
                            mt-5
                            text-xs-center
                            v-else-if="isError"
                            class="no-results">
                            <v-flex tag="span">{{NoResults}}</v-flex>
                        </v-flex>
                        <v-flex v-else>
                            <BusinessesList :businessesData="paginatedData"></BusinessesList>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <v-flex xs12 v-if="!$vuetify.breakpoint.xs" :class="isSearchClicked ? 'sm7 lg8' : 'sm12 lg12'">
                    <BusinessesMap :mapList="assetMapPins" :centerTo="maplocation"></BusinessesMap>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex mt-3 v-if="totalEstablishments.length > 0">
            <v-pagination v-model="pagination.page" :length="pages" :total-visible="businessesConstants.PAGINATION_LENGTH"></v-pagination>
        </v-flex>
        <v-flex>
            <v-dialog
                scrollable
                v-model="showAssetInfoDialog"
                content-class="extra-small"
                persistent>
                <BusinessesInformation :closeDialog="closeDialog" :establishmentData="establishmentData"></BusinessesInformation>
            </v-dialog>
        </v-flex>
        <confirmation-dialog 
            v-model="showLocationBlockDialog"
            typeOfDialog="alert"
            :title="businessesConstants.GEOLOCATION_BLOCKED_TITLE"
            :message="businessesConstants.GEOLOCATION_BLOCKED"
            :yesText="appCommonConstants.OK">
        </confirmation-dialog>
    </v-flex>
</template>

<script>
    import BusinessFilters from "./BusinessFilters";
    import BusinessActiveFilters from "./BusinessActiveFilters";
    import BusinessesMap from "../BusinessesMap/BusinessesMap";
    import BusinessesList from "./BusinessesList";
    import { appCommonConstants } from "./../appCommon.constants";
    import { businessesConstants, businessFilters, businessesSortOptions, emptyFilters } from './businesses.constants';
    import { assetSummaryConstants } from '../MemberProfile/memberProfile.constants';
    import isEmpty from 'lodash/isEmpty';
    import orderBy from 'lodash/orderBy';
    import uniq from 'lodash/uniq';
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import ClickOutside from "vue-click-outside";
    import FeatureEvent from '../ChapterPage/FeatureEvent/FeatureEvent';
    import BusinessesInformation from "../BusinessesMap/BusinessesInformation";
    import ConfirmationDialog from '../MemberProfile/EditDialogues/ConfirmationDialog';
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: "Businesses",
        components: {
            BusinessFilters,
            BusinessActiveFilters,
            BusinessesMap,
            BusinessesList,
            FeatureEvent,
            BusinessesInformation,
            ConfirmationDialog,
        },
        data() {
            return {
                appCommonConstants,
                assetSummaryConstants,
                businessesConstants,
                businessFilters,
                showBusinessFilters: false,
                activeBusinessFilters: false,
                businessesSortOptions,
                currentGeolocation: '',
                currentFullGeolocation: '',
                isChanged: true,
                location: '',
                locality: '',
                state: '',
                city: '',
                establishmentsSearchText: '',
                locationSearchSuggestionSelected: '',
                establishmentSearchSuggestionSelected: '',
                establishmentSuggestions: [],
                isCurrentLoc: false,
                locationSuggestions: [],
                totalEstablishments: [],
                isPending: false,
                NoResults: businessesConstants.NO_RESULTS,
                isError: false,
                sortoption: businessesConstants.ASSET_SORT,
                showAssetInfoDialog: false,
                establishmentData: {},
                showLocationBlockDialog: false,
                isSearchClicked: false,
                filtersUpdationDate: 0,
                locationNotFoundError: false,
                distanceSwitch: true,
                filters: emptyFilters,
                locationTextEntered: '',
                establishmentsTextEntered: '',
                isLocationSearchSuggestionSelected: false,
                pagination: {
                    page: businessesConstants.CURRENT_PAGE,
                    rowsPerPage: businessesConstants.ROWS_PER_PAGE,
                },
                maplocation: {
                    lat: 0,
                    lng: 0,
                },
                counters: {
                    establishmentsCounter: -1,
                    locationsCounter: -1,
                },
                filtersEnabled: {
                    establishments: [],
                    cuisineTypes: [],
                    accommodationTypes: [],
                    starRatings: [],
                    prices: [],
                    hotelClassTypes: [],
                    ownershipTypes: [],
                    distances: [],
                },
                currentLocationCoordinates: {
                    Latitude: 0,
                    Longitude: 0,
                },
                searchedLocationCoordinates: {
                    Latitude: 0,
                    Longitude: 0,
                },
                timerId: '',
                hideLocationsSuggestions: true,
                hideEstablishmentSuggestions: true,

            };
        },
        mounted() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.setCurrentGeolocation(position);
                });
            }
        },
        created() {
            this.setSearchAssets([]);
        },
        methods: {                   
            ...mapActions({
                getSearchEstablishments: `businesses/${storeAction.getSearchEstablishments}`,
                getSearchLocations: `businesses/${storeAction.getSearchLocations}`,
                getSearchAssets: `businesses/${storeAction.getSearchAssets}`,
            }),
            ...mapMutations({
                resetShowAssetId: `businesses/${storeMutation.resetShowAssetId}`,
                setSearchAssets: `businesses/${storeMutation.setSearchAssets}`,
            }),
            setCurrentGeolocation(position) {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.currentLocationCoordinates.Latitude = pos.lat;
                this.currentLocationCoordinates.Longitude = pos.lng;
                setTimeout(() => {
                    /* eslint-disable-next-line no-undef*/
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ 'location': pos }, (results) => {
                        if (results) {
                            let address = results.find(add => add.types.includes('locality'));
                            if (!address) {
                                address = results.find(add => add.types.includes('administrative_area_level_2'));
                            }
                            this.setDefaultLocation(address);
                        }
                    });
                }, 1000);
            },
            setDefaultLocation(address) {
                let locality = '';
                let state = '';
                let fullState = '';
                let fullCountry = ''; 
                let country = '';
                let place = '';
                this.maplocation = {
                    lat: address.geometry.location.lat(),
                    lng: address.geometry.location.lng(),
                };
                address.address_components.forEach((j) => {
                    if (j.types.includes('locality') && !locality) {
                        locality = j.long_name;
                    }
                    if (j.types.includes('administrative_area_level_2') && !locality) {
                        locality = j.long_name;
                    }
                    if (j.types.includes("administrative_area_level_1")) {
                        state = j.short_name;
                        fullState = j.long_name;
                    }
                    if (j.types.includes("country")) {
                        country = j.short_name;
                        fullCountry = j.long_name;
                    }
                });
                if (locality) {
                    place = locality;
                    this.locality = locality;
                    this.city = locality;
                }
                if (state) {
                    place += `, ${state}`;
                    this.state = fullState;
                    this.currentFullGeolocation = `${locality}, ${fullState}`;                    
                } else if (country) {
                    place += `, ${country}`;
                    this.currentFullGeolocation = `${locality}, ${fullCountry}`;
                }
                this.currentGeolocation = place;
                this.isChanged = false;
            },
            setStateAndLocality(address) {
                let locality = '';
                let state = '';
                let fullState = '';
                this.city = '';
                this.state = '';
                
                address.address_components.forEach((j) => {
                    if (j.types.includes('locality') && !locality) {
                        locality = j.long_name;
                    }
                    if (j.types.includes('administrative_area_level_2') && !locality) {
                        locality = j.long_name;
                    }
                    if (j.types.includes("administrative_area_level_1")) {
                        state = j.short_name;
                        fullState = j.long_name;
                    }                    
                });
                if (locality) {
                    this.city = locality;
                }
                if (state) {
                    this.state = fullState;
                } 
            },
            getLocationPlaceholder() {
                return this.isChanged ? businessesConstants.LOCATION_PLACEHOLDER : this.currentGeolocation;
            },
            getSearchResults() {
                this.showBusinessFilters = false;
                this.activeBusinessFilters = false;
                this.getEstablishments();
            },
            checkGPSEnabled() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        console.log(position);
                    }, () => {
                        this.showLocationBlockDialog = true;
                    });
                }
            },
            populateCurrentLocation() {
                this.isCurrentLoc = true;
                this.checkGPSEnabled();
                if (this.currentGeolocation === '') {
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.setCurrentGeolocation(position);
                    }).then(() => {
                        this.location = this.currentGeolocation;
                        this.searchedLocationCoordinates = this.currentLocationCoordinates;
                    });
                }
                this.location = this.currentGeolocation;
                this.searchedLocationCoordinates = this.currentLocationCoordinates;
                gaDataLayerEvent(gtmEventName.C_Around_Me_Current_Location, this.location);
            },
            onLocationChange() {
                this.isCurrentLoc = false;
                this.isChanged = true;
                this.locality = "";
                this.locationSearchSuggestionSelected = '';
            },
            getEstablishments() {
                this.isSearchClicked = true;
                this.pagination.page = this.businessesConstants.CURRENT_PAGE;
                this.isPending = true;
                this.isError = false;
                const locationText = this.isChanged ? this.location : this.currentFullGeolocation;
                const requestbody = {
                    SearchText: this.establishmentSearchSuggestionSelected ? this.establishmentSearchSuggestionSelected : this.establishmentsSearchText.trim(),
                    location: this.locationSearchSuggestionSelected ? this.locationSearchSuggestionSelected : locationText,
                    Coordinates: this.location ? this.searchedLocationCoordinates : this.currentLocationCoordinates,
                    SearchLocationTextEntered: this.locationTextEntered,
                    SearchEstablishmentTypeTextEntered: this.establishmentsTextEntered,
                    isLocationSearchSuggestionSelected: this.isLocationSearchSuggestionSelected,
                };
                this.getSearchAssets(requestbody).then(() => {
                    this.resetFilters();
                    this.doRefineFilters();
                    this.findEnableFilters();
                    this.isPending = false;
                    this.isLocationSearchSuggestionSelected = false;
                })
                .catch(() => {
                    this.isPending = false;
                    this.isError = true;
                    this.isLocationSearchSuggestionSelected = false;
                });
            },
            getEstablishmentSuggestions() {
                this.establishmentsTextEntered = this.establishmentsSearchText;
                this.counters.establishmentsCounter = -1;
                if (this.establishmentsSearchText.length < this.businessesConstants.SEARCH_ALLOW_LENGTH) {
                    this.establishmentSuggestions = [];
                    this.establishmentSearchSuggestionSelected = ''; 
                    return false;
                }
                const requestbody = {
                    SearchText: this.establishmentsSearchText.trim(),
                    location: this.isChanged ? this.location : this.currentFullGeolocation,
                    Coordinates: this.location ? this.searchedLocationCoordinates : this.currentLocationCoordinates,
                    City: this.city,
                    State: this.state,
                };
                this.getSearchEstablishments(requestbody)
                    .then((res) => {
                      this.establishmentSuggestions = res.data;
                    })
                    .finally(() => {
                      gaDataLayerEvent(gtmEventName.C_Around_Me_Establishment_Search_Text, requestbody.SearchText);
                    });
                this.establishmentSearchSuggestionSelected = '';
            },
            selectEstablishments(value) {
                if (value) {
                    this.establishmentsSearchText = value;
                    this.establishmentSearchSuggestionSelected = value;
                }
                this.establishmentSuggestions = [];
              gaDataLayerEvent(gtmEventName.C_Around_Me_Establishment_Search_Suggestion_Selected, value);
              this.getEstablishments();
            },
            async selectLocationDropDown(value) {
                if (value) {  
                    await this.setSearchedLocationCoordinates(value);
                }
                clearTimeout(this.timerId);
                    this.timerId = setTimeout(() => {
                    this.selectLocation(value);
                    gaDataLayerEvent(gtmEventName.C_Around_Me_Location_Selected, value);
                    }, 500);   
            },
            async selectLocation(value) {
                if (value) {
                    this.location = value;
                    this.locationSearchSuggestionSelected = value;
                    await this.setSearchedLocationCoordinates(value);
                    this.isLocationSearchSuggestionSelected = true;
                }
                this.locationSuggestions = [];
                this.getEstablishments();
            },
            closeLocationSuggestions() {
                this.hideLocationsSuggestions = true;                
            },  
            closeEstablismentSuggestions() {                
                this.hideEstablishmentSuggestions = true;
            },            
            showEstablishmentSuggestions() {
                this.hideLocationsSuggestions = true;
                this.hideEstablishmentSuggestions = false;
            },           
            showLocationSuggestions() {
                this.hideLocationsSuggestions = false;
                this.hideEstablishmentSuggestions = true;
            },
             fetchEntriesDebounceEstablishmentSuggestions() {
                this.hideLocationsSuggestions = true;
                this.hideEstablishmentSuggestions = false;
                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.getEstablishmentSuggestions();
                }, 500);
            },
            fetchEntriesDebounceLocationSuggestions() {
                this.hideLocationsSuggestions = false;
                this.hideEstablishmentSuggestions = true;
                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.getLocationSuggestions();
                }, 500);
            },
            getLocationSuggestions() {
                this.locationTextEntered = this.location;
                this.counters.locationsCounter = -1;
                if (this.location.length < this.businessesConstants.SEARCH_ALLOW_LENGTH) {
                    this.locationSuggestions = [];
                    return false;
                }
                this.setSearchedLocationCoordinates(this.location);
                const requestbody = {
                    location: this.location,
                };
                this.getSearchLocations(requestbody)
                    .then((res) => {
                    if (res.data.length > 0) {
                        this.locationNotFoundError = false;
                        this.locationSuggestions = res.data;
                    } else {
                        this.locationNotFoundError = true;
                    }
                }).finally(() => {
                  gaDataLayerEvent(gtmEventName.C_Around_Me_Location_Search_Text, requestbody.location);
                });
            },
            doSort(data) {
                this.sortoption = data.label;
                this.totalEstablishments = orderBy(this.totalEstablishments, [item => (isEmpty(item[data.sortField]) ? '' : item[data.sortField].toLowerCase())], data.direction);
            },
            closeDialog() {
                this.showAssetInfoDialog = false;
                this.resetShowAssetId();
            },
            resetFilters() {
                this.sortoption = this.businessesConstants.ASSET_SORT;
                this.filtersUpdationDate = new Date().getTime();
            },
            onArrowDown(results, counter) {
                if (this.counters[counter] < results.length) {
                    this.counters[counter] = this.counters[counter] + 1;
                } else {
                    this.counters[counter] = 0;
                    this.$refs[counter].scrollTop = 0;
                }
                if (this.counters[counter] >= 9) {
                    this.$refs[counter].scrollTop += this.businessesConstants.EACH_OPTION_LENGTH;
                }
            },
            onArrowUp(results, counter) {
                if (this.counters[counter] >= 9) {
                    this.$refs[counter].scrollTop -= this.businessesConstants.EACH_OPTION_LENGTH;
                }
                if (this.counters[counter] > 0) {
                    this.counters[counter] = this.counters[counter] - 1;
                } else {
                    this.counters[counter] = (results.length - 1);
                    this.$refs[counter].scrollTop = this.$refs[counter].scrollHeight - this.businessesConstants.EACH_OPTION_LENGTH;
                }
            },
            async onEnter(results, counter) {     
                if (this.location) {
                    await this.setSearchedLocationCoordinates(this.location);
                }           
                if (counter === this.businessesConstants.ESTABLISHMENT_COUNTER) {
                    clearTimeout(this.timerId);
                    this.timerId = setTimeout(() => {
                    this.selectEstablishments(results[this.counters[counter]]);
                    }, 500);                      
                } else if (counter === this.businessesConstants.LOCATION_COUNTER) {
                    clearTimeout(this.timerId);
                    this.timerId = setTimeout(() => {
                    this.selectLocation(results[this.counters[counter]]);
                    }, 500);                    
                }
                this.counters[counter] = -1;
            },
            doRefineFilters(filters) {
                if (filters) {
                    this.filters = filters;
                }
                this.isError = false;
                this.NoResults = this.businessesConstants.NO_RESULTS;
                this.totalEstablishments = this.searchedAssets.slice();
                if (this.totalEstablishments.length > 0) {
                    Object.keys(this.filters).forEach((filter) => {
                        this.filterTotalEstablishments(filter);
                    });

                    if (this.searchedAssets.length > 0 && this.totalEstablishments.length <= 0) {
                        this.isError = true;
                        this.NoResults = `${this.businessesConstants.NO_RESULTS} ${this.businessesConstants.REMOVE_FILTERS}`;
                    }
                } else {
                    this.isError = true;
                }

                if (this.$refs.activeFilters && this.$refs.activeFilters.setActiveFilters) {
                    this.$refs.activeFilters.setActiveFilters(this.filters);
                }               
            },
            filterTotalEstablishments(filter) {
                const fieldName = this.getFieldByFiltertype(filter);
                const filterValues = this.filters[filter];
                if (filterValues.length > 0) {
                    if (fieldName === this.businessFilters.ownershipTypes) {
                        this.totalEstablishments = this.filterByRelationship(filterValues);
                    } else if (fieldName === this.businessFilters.cuisineTypes) {
                        this.totalEstablishments = this.totalEstablishments.filter(item => item[fieldName] !== null && filterValues.some(x => item[fieldName].indexOf(x) > -1));
                    } else if (fieldName === this.businessFilters.distances) {
                        this.totalEstablishments = this.filterByDistance(filterValues);
                    } else {
                        this.totalEstablishments = this.totalEstablishments.filter(item => item[fieldName] !== null && filterValues.includes(item[fieldName])); 
                    }   
                }
            },
            getFieldByFiltertype(value) {
                return this.businessFilters[value];
            },
            findEnableFilters() {
                Object.keys(this.businessFilters).forEach((filter) => {
                    const filterKey = this.businessFilters[filter];
                    const filterValues = this.searchedAssets.filter(x => x[filterKey] !== null).map(x => x[filterKey]);
                    if (filterKey === this.businessFilters.ownershipTypes) {
                        this.filtersEnabled[filter] = this.findEnablesForRelationship(filterValues);
                    } else if (filterKey === this.businessFilters.distances) {
                        this.filtersEnabled[filter] = this.findEnablesForDistance(filterValues);
                    } else {
                        this.filtersEnabled[filter] = uniq(filterValues);
                    }     
                });
                this.filtersUpdationDate = new Date().getTime();
            },
            filterByRelationship(filterValues) {
                let assets = [];
                const types = this.businessesConstants.RELATIONSHIP_TYPES;
                if (filterValues.length === 0) {
                    assets = this.totalEstablishments.slice();
                } else if (filterValues.length === 2) {
                    assets = this.totalEstablishments.filter(x => !isEmpty(x.personAssetRelation));
                } else if (filterValues.length === 1 && filterValues[0] === this.businessesConstants.OWNERSHIP_TYPES[0]) {
                    assets = this.totalEstablishments.filter(item => item.personAssetRelation.length > 0 && item.personAssetRelation.some(res => res.relationshipToAsset.includes(types[0]) || res.relationshipToAsset.includes(types[1]) || res.relationshipToAsset.includes(types[2])));
                } else if (filterValues.length === 1 && filterValues[0] === this.businessesConstants.OWNERSHIP_TYPES[1]) {
                    assets = this.totalEstablishments.filter(item => item.personAssetRelation.length > 0 && item.personAssetRelation.some(res => res.relationshipToAsset.includes(types[3])));
                } 
                return assets;
            },
            findEnablesForRelationship(filterValues) {
                const relationships = [];
                const types = this.businessesConstants.RELATIONSHIP_TYPES;
                const personAssetRelations = [];
                filterValues.forEach(res => personAssetRelations.push(...res.filter(x => x.relationshipToAsset != null).map(x => x.relationshipToAsset)));
                if (personAssetRelations.some(res => res.includes(types[0]) || res.includes(types[1]) || res.includes(types[2]))) {
                    relationships.push(this.businessesConstants.OWNERSHIP_TYPES[0]);
                }
                if (personAssetRelations.some(res => res.includes(types[3]))) {
                    relationships.push(this.businessesConstants.OWNERSHIP_TYPES[1]);
                }
                return relationships;
            },
            getStartIndex() {
                const start = (this.pagination.page - 1) * this.pagination.rowsPerPage;
                if (this.totalEstablishments.length <= start) {
                    const page = (this.totalEstablishments.length / this.pagination.rowsPerPage) + 1;
                    this.pagination.page = parseInt(page, 10);
                    return (this.pagination.page - 1) * this.pagination.rowsPerPage;
                }
                return start;
            },
            showfilters() {
                this.showBusinessFilters = !this.showBusinessFilters;
                this.activeBusinessFilters = false;
            },
            findEnablesForDistance(values) {
                const enabledDistances = [];
                if (!this.distanceSwitch) {
                    values = this.searchedAssets.filter(x => x.distanceKilometers !== null && x.distanceKilometers !== 0)
                                            .map(x => x.distanceKilometers);
                }
                if (values.some(x => x > 0 && x <= 1)) {
                    enabledDistances.push(1);
                }
                if (values.some(x => x > 1 && x <= 2)) {
                    enabledDistances.push(2);
                }
                if (values.some(x => x > 2 && x <= 5)) {
                    enabledDistances.push(5);
                }
                if (values.some(x => x > 5 && x <= 10)) {
                    enabledDistances.push(10);
                }
                if (values.some(x => x > 10 && x <= 25)) {
                    enabledDistances.push(25);
                }
                return enabledDistances;
            },
            filterByDistance(filterValues) {
                let assets = [];
                const field = this.distanceSwitch ? 'distanceMiles' : 'distanceKilometers';
                if (filterValues.length === 0) {
                    assets = this.totalEstablishments.slice();
                } else {
                    if (filterValues.some(x => x > 0 && x <= 1)) {
                        assets.push(...this.totalEstablishments.filter(x => x[field] > 0 && x[field] <= 1));
                    }
                    if (filterValues.some(x => x > 1 && x <= 2)) {
                        assets.push(...this.totalEstablishments.filter(x => x[field] > 1 && x[field] <= 2));
                    }
                    if (filterValues.some(x => x > 2 && x <= 5)) {
                        assets.push(...this.totalEstablishments.filter(x => x[field] > 2 && x[field] <= 5));
                    }
                    if (filterValues.some(x => x > 5 && x <= 10)) {
                        assets.push(...this.totalEstablishments.filter(x => x[field] > 5 && x[field] <= 10));
                    }
                    if (filterValues.some(x => x > 10 && x <= 25)) {
                        assets.push(...this.totalEstablishments.filter(x => x[field] > 10 && x[field] <= 25));
                    }
                } 
                return assets;
            },
            setSearchedLocationCoordinates(location) {
                if (!location) return false;
                /* eslint-disable-next-line no-undef*/
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': location }, ((results) => {
                    if (results && results.length > 0) {
                        this.searchedLocationCoordinates = {
                            Latitude: results[0].geometry.location.lat(),
                            Longitude: results[0].geometry.location.lng(),
                        };  
                        this.setStateAndLocality(results[0]);                       
                    }
                }));
            },
            setDistanceSwitch(value) {
                this.distanceSwitch = value;
                this.findEnableFilters();
            },
        },
        directives: {
            ClickOutside,
        },
        computed: {
            ...mapGetters({
                searchedAssets: `businesses/${storeGetters.searchedAssets}`,
                showAssetId: `businesses/${storeGetters.showAssetId}`,
            }),
            pages() {
                const pageLength = this.totalEstablishments.length / this.pagination.rowsPerPage;
                return (this.totalEstablishments.length % this.pagination.rowsPerPage === 0) ? pageLength : Math.floor(pageLength + 1);
            },
            paginatedData() {
                const start = this.getStartIndex();
                const end = start + this.pagination.rowsPerPage;
                return this.totalEstablishments.slice(start, end);
            },
            assetMapPins() {
                return this.paginatedData.filter(x => x.longitude !== null && x.latitude !== null);
            },
        },
        watch: {
            showAssetId(val) {
                if (val) {
                    this.showAssetInfoDialog = true;
                    this.establishmentData = this.totalEstablishments.find(e => e.id === val);
                    this.resetShowAssetId(false);
                }
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .businesses {
        &__feature {
            height: 300px;
            overflow: hidden;
            position: relative;

            img {
                max-width: 100%;
            }

            &:before {
                content: "";
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: rgba($ypo-blue, 0.35)
            }

            &__cont {
                position: absolute;
                top: 0;
                left: 0;
                color: $white;
                height: 100%;
                padding-left: 40px;

                h2 {
                    font-size: 30px;
                    text-align: center;
                    align-items: center;
                    margin-top: 100px;

                    span {
                        display: block;
                    }
                }

                small {
                    position: absolute;
                    bottom: 5px;
                    font-size: 15px;
                    font-style: italic;
                    letter-spacing: -0.14px;
                }
            }
        }

        &__search {
            position: relative;

            &__result {
                background: $white;
                border-top: 0;
                box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                border: 1px solid rgba($ypo-gray, 0.4);
                border-radius: 0 0 3px 3px;
                position: absolute;
                width: 98% !important;
                z-index: 2;
                max-height: 400px;
                overflow-y: auto;

                &--error {
                    color: $ypo-error-red !important;
                }

                span {
                    display: block;
                    border-bottom: 1px solid rgba($ypo-gray, 0.1) !important;
                    color: $ypo-blue;
                    padding: 10px;
                    cursor: pointer;

                    &:last-child {
                        border-bottom: 0;
                    }
                    &.is-active,
                    &:hover {
                        background-color: rgba($ypo-gray, 0.1);
                    }
                }
            }
            &__block {
                .form-control {
                    .v-input__control {
                        min-height: 43px; 
                        .v-label {
                            font-size: 14px;
                            font-style: italic;
                            padding-right: 6px;
                        }
                    }
                }
            }
        }
        .form-control {
            .v-input__slot {
                box-shadow: none !important;
                border: 1px solid $ypo-medium-gray;
                border-radius: 3px !important;
                margin-bottom: 0px;

                ::placeholder {
                    font-size: 12px;
                }
            }

            .v-input__icon {
                i {
                    font-size: 18px;
                    color: $ypo-blue-dark-background;
                }
            }

            .v-text-field__details {
                display: none;
            }

            &.small {
                margin-top: 5px;
            }

            &.current-loc {
                .v-text-field__slot {
                    input {
                        color: $ypo-cta;
                    }
                }
            }

            &__label {
                font-size: 14px;
                display: block;
                font-weight: 600;
                margin-top: -5px;
            }
        }

        &__search-btn {
            width: 100%;
            margin: 5px 0 0 0 !important;
        }

        &__current-location {
            color: $ypo-cta;
            font-size: 14px;
            cursor: pointer;
            font-weight: 600;

            &:hover {
                color: $ypo-blue;
            }
        }

        .no-results {
            color: $ypo-red;
        }
        &__results_view {
            position: relative;
        }

        @include breakpoint(xs) {
            &__search {
                padding-right: 0px !important;
                &__block {
                    background: $white;
                    padding: 10px;
                    border-radius: 3px;
                    border: 1px solid $ypo-medium-gray;
                    margin: 15px 0px !important;
                }
                &.search_establishments {
                    margin-bottom: 10px;
                }
                &-btn__block {
                    margin-left: 50%;
                }
            }
            .form-control {
                margin-right: 0px !important;
                .v-input__control {
                   min-height: 38px; 
                }
            } 
        }
        .filter-icon {
            width: 34px;
            height: 34px;
            background-color: $ypo-cta;
            border-radius: 100%;
            text-align: center;
            cursor: pointer;
            display: inline-block;
            margin-top: 5px;
            i {
                color: $white;
                font-size: 16px;
                margin-top: 9px;
            }
        }
    }

    .asset-info-dialog {
        .v-card__title {
            font-size: 16px !important;
            padding: 10px 40px 10px 10px !important;
            line-height: normal !important;
            font-weight: 600 !important;
        }
    }
    .asset-results_menu {
        .v-list__tile {
            font-size: 14px;
            height: 35px;
            padding: 0 10px;
        }
    }
</style>
